import { Dialog, DialogContent, withStyles } from "@material-ui/core";
import { Formik } from 'formik';
import React from 'react';
import { request } from '../../../../api-client';
import { getStoredUser } from '../../../../api-client/core/authentication/utils';
import * as BFH from "../../../../components/Letflow/Form/BloomcloudsFormHelpers";
import GlobalSnackbar, { GlobalSnackbarTypes } from '../../../../components/Letflow/Snackbar/GlobalSnackbar';
import localization from '../../../../config/localization';

const styles = {
  dialogPaper: {
      borderRadius: '10px',
      maxWidth: '750px'
  },
};

class ProfileUrlModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      submitted: false,
    }
  }

  handleModalClose = () => {
    this.props.onClose && this.props.onClose();
  }

  getProfileLink = () => {
    let currentUser = getStoredUser();
    let contentCreator = currentUser && currentUser.contentCreator;
    if (!contentCreator) return;
    return contentCreator.profile_url ? `${window.location.protocol}//${window.location.hostname}/bl/${contentCreator.profile_url}` : `${window.location.protocol}//${window.location.hostname}/public/content_creators/${contentCreator.hashcode}`
  }

  initialValues = () => {
    let currentUser = getStoredUser();
    let contentCreator = currentUser && currentUser.contentCreator;
    return {
      profileUrl: contentCreator ? contentCreator.profile_url : '',
    }
  }
  
  validate = values => {
    console.log(values.profileUrl);
    let currentUser = getStoredUser();
    let contentCreator = currentUser && currentUser.contentCreator;
    if (contentCreator.profile_url && contentCreator.profile_url == values.profileUrl) {
      return {};
    }
    if (!values.profileUrl || values.profileUrl.length == 0) {
      return {profileUrl: localization.get("form.validation.required")};
    }
    if (contentCreator) {
      var regex = /^[a-z0-9-_\.]+$/;
      if(!regex.test(values.profileUrl)) {
        return {profileUrl: localization.get("talent_profile.edit_url_modal.invalid_chars")}
      }
      return request.contentCreator.checkProfileUrl(values.profileUrl).then(
        response => {
          if (response && !response.available) {
            throw {profileUrl: localization.get("talent_profile.edit_url_modal.url_in_use")};
          }
        }
      )
    }
  };

  submit(values) {
    let currentUser = getStoredUser();
    let contentCreator = currentUser && currentUser.contentCreator;
    if (contentCreator.profile_url && contentCreator.profile_url == values.profileUrl) {
      return Promise.resolve(true);
    }
    return request.contentCreator.setProfileUrl(values.profileUrl);
  }

  render = () => {
    const { classes } = this.props;
    return (
      <Dialog
        disableEnforceFocus
        style={{zIndex: 999}}
        open={this.props.open}
        onEscapeKeyDown={this.handleModalClose}
        fullWidth
        classes={{paper: classes.dialogPaper}}
        maxWidth="md"
      >
        <div style={{
          backgroundColor: "#353535",
          borderRadius: '10px',
          color: "white",
          height: '100%',
          overflow: 'auto'
        }}>
          <DialogContent style={{padding: '0', height: '100%'}}>
            <Formik
              initialValues={this.initialValues()}
              validate={this.validate}
              onSubmit={(values, actions) => {
                this.submit(values)
                  .then((response) => {
                    GlobalSnackbar.show({message: localization.get("talent_profile.edit_url_modal.url_updated"), type: GlobalSnackbarTypes.SUCCESS})
                    this.handleModalClose();
                    this.setState({ submitted: true });
                    setTimeout(() => {
                      window.location.reload();
                    }, 2000);
                  })
                  .catch(e => {
                    let error = e && e.error;
                    error = JSON.parse(error);
                    if (error && error.message) {
                      GlobalSnackbar.show({message: error.message, type: GlobalSnackbarTypes.ERROR})
                    } else {
                      GlobalSnackbar.showGenericError();
                    }
                  })
              }}
            >
              {formikProps =>
                <React.Fragment>
                  <form autoComplete="off">
                    <FormView
                      errors={formikProps.errors}
                      touched={{profileUrl: true}}
                      onChange={(field, value) => {
                        formikProps.setFieldValue(field, value);
                      }}
                      onSubmit={(e) => {
                        this.setState({showErrors: true});
                        formikProps.handleSubmit(e);
                      }}
                      submitted={this.state.submitted}
                      formikProps={formikProps}
                      onCancel={this.handleModalClose}
                      originalProfileLink={this.getProfileLink()}
                    />
                  </form>
                </React.Fragment>
              }
            </Formik>
          </DialogContent>
        </div>
      </Dialog>
    );
  }
}

const FormView = ({
  errors,
  touched,
  submitted,
  onChange,
  onSubmit,
  formikProps,
  showErrors,
  onCancel,
  originalProfileLink
}) => {
  return (
    <BFH.FormContainer errors={errors} touched={touched} onChange={onChange} noMargin={true}>
      <BFH.SectionTitle>{localization.get("talent_profile.edit_url_modal.title")}</BFH.SectionTitle>
      <BFH.InputContainer>
        <BFH.FieldTitle>{localization.get("talent_profile.edit_url_modal.old_url")}</BFH.FieldTitle>
        <BFH.Input
          field="originalProfileLink"
          type="text"
          value={originalProfileLink}
          disabled={true}
        />
      </BFH.InputContainer>
      <BFH.InputContainer>
        <BFH.FieldTitle>{localization.get("talent_profile.edit_url_modal.new_url")} *</BFH.FieldTitle>
        <BFH.PrefixedInput
          field="profileUrl"
          type="text"
          value={formikProps.values.profileUrl}
          prefix={`${window.location.protocol}//${window.location.hostname}/bl/`}
        />
      </BFH.InputContainer>
      <BFH.SubmitButton
        onClick={onSubmit}
        disabled={submitted}
        onCancel={onCancel}
        isModal={true}
        hasErrors={showErrors && Object.keys(errors).length > 0}
      />
    </BFH.FormContainer>
  );
};

export default withStyles(styles)(ProfileUrlModal);